import { fitApi } from '.';

// Bu dosya API generator tarafından üretilmez — güvenle düzenlenebilir.
export const fitApiWithTags = fitApi.enhanceEndpoints({
  endpoints: {
    // ---- Medicine Reminder ----
    getActiveMedicineRemindersByUserId: {
      providesTags: ['MedicineReminder'],
    },
    getMedicineRemindersByUserId: { providesTags: ['MedicineReminder'] },
    getMedicineReminderById: { providesTags: ['MedicineReminder'] },
    createMedicineReminder: { invalidatesTags: ['MedicineReminder'] },
    updateMedicineReminder: { invalidatesTags: ['MedicineReminder'] },
    deleteMedicineReminder: { invalidatesTags: ['MedicineReminder'] },

    // ---- Targets ----
    getTargets: { providesTags: ['Targets'] },
    getTargetById: { providesTags: ['Targets'] },
    createTarget: { invalidatesTags: ['Targets'] },
    updateTarget: { invalidatesTags: ['Targets'] },
    deleteTarget: { invalidatesTags: ['Targets'] },

    // ---- Levels ----
    getLevels: { providesTags: ['Levels'] },
    getLevelById: { providesTags: ['Levels'] },
    createLevel: { invalidatesTags: ['Levels'] },
    updateLevel: { invalidatesTags: ['Levels'] },
    deleteLevel: { invalidatesTags: ['Levels'] },

    // ---- Exercise Types ----
    getExerciseTypes: { providesTags: ['ExerciseTypes'] },
    getExerciseTypeById: { providesTags: ['ExerciseTypes'] },
    createExerciseType: { invalidatesTags: ['ExerciseTypes'] },
    updateExerciseType: { invalidatesTags: ['ExerciseTypes'] },
    deleteExerciseType: { invalidatesTags: ['ExerciseTypes'] },

    // ---- Exercises ----
    getExerciseById: { providesTags: ['Exercises'] },
    getByExercisePlan: { providesTags: ['Exercises'] },
    createExercise: { invalidatesTags: ['Exercises'] },
    updateExercise: { invalidatesTags: ['Exercises'] },
    deleteExercise: { invalidatesTags: ['Exercises'] },

    // ---- User Exercises ----
    getUserExercisesByUserId: { providesTags: ['UserExercise'] },
    getUserExerciseByExerciseIdAndUserId: { providesTags: ['UserExercise'] },
    createUserExercise: { invalidatesTags: ['UserExercise'] },
    updateUserExercise: { invalidatesTags: ['UserExercise'] },
    deleteUserExercise: { invalidatesTags: ['UserExercise'] },
    createOrUpdateUserExercise: { invalidatesTags: ['UserExercise'] },

    // ---- Daily Step ----
    getDailyStepByUserId: { providesTags: ['DailyStep'] },
    createDailyStep: { invalidatesTags: ['DailyStep'] },
    updateDailyStep: { invalidatesTags: ['DailyStep'] },

    // ---- Drink Activity ----
    getTodayDrinkActivity: { providesTags: ['DrinkActivity'] },
    getByDateDrinkActivity: { providesTags: ['DrinkActivity'] },
    getWeeklyDrinkActivity: { providesTags: ['DrinkActivity'] },
    createDrinkActivity: { invalidatesTags: ['DrinkActivity'] },

    // ---- Water Consumption ----
    getWaterConsumption: { providesTags: ['WaterConsumption'] },
    getWaterConsumptionByUserId: { providesTags: ['WaterConsumption'] },
    createWaterConsumption: { invalidatesTags: ['WaterConsumption'] },
    updateWaterConsumption: { invalidatesTags: ['WaterConsumption'] },
    deleteWaterConsumption: { invalidatesTags: ['WaterConsumption'] },

    // ---- Water Options ----
    getWaterOptionsByUserId: { providesTags: ['WaterOptions'] },
    getWaterOptionById: { providesTags: ['WaterOptions'] },
    createWaterOption: { invalidatesTags: ['WaterOptions'] },
    deleteWaterOption: { invalidatesTags: ['WaterOptions'] },

    // ---- Reminder Notification ----
    getAllEnabledReminderNotifications: {
      providesTags: ['ReminderNotification'],
    },
    getReminderNotificationByUserId: {
      providesTags: ['ReminderNotification'],
    },
    createReminderNotification: { invalidatesTags: ['ReminderNotification'] },
    updateReminderNotification: { invalidatesTags: ['ReminderNotification'] },

    // ---- Pharmacies ----
    getPharmaciesByCityAndDistrictAsync: { providesTags: ['Pharmacies'] },
    getPharmaciesNearLocationAsync: { providesTags: ['Pharmacies'] },

    // ---- Hospitals ----
    getHospitalsAsync: { providesTags: ['Hospitals'] },
    getHospitalsLocationsAsync: { providesTags: ['Hospitals'] },

    // ---- Videos ----
    getAllVideos: { providesTags: ['FitVideos'] },
    getVideo: { providesTags: ['FitVideos'] },
  },
});
